import React, { ReactElement, ForwardedRef } from 'react';
import Slide from '@mui/material/Slide';

const ModalTransition: ReactMemoComponent = React.memo(React.forwardRef<HTMLElement, SlidePropsExtended>((
  props: ReactComponentProps,
  ref: ForwardedRef<HTMLElement>,
): ReactElement => {
  const DIRECTION_UP: string = 'up';

  return (
    <Slide
      ref={ref}
      direction={DIRECTION_UP}
      {...props}
    />
  );
}));

export default ModalTransition;
